<template>
  <div>
    <div v-show="value" class="fixed top-0 left-0 z-40 w-full h-full bg-overlay" />
    <div v-show="value" class="fixed top-0 left-0 z-40 w-full h-full overflow-hidden">
      <div class="absolute top-0 left-0 flex flex-wrap items-center justify-center w-full h-full p-5 overflow-x-auto">
        <div class="relative w-full max-w-xl px-5 pt-8 pb-6 bg-white xl:py-10 xl:px-8">
          <div
            v-if="dismissable"
            class="absolute top-0 right-0 mt-4 mr-4 cursor-pointer"
            @click="$emit('input', false)"
          >
            <svg fill="none" viewBox="0 0 20.188 20.187" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-4 h-4 fill-current text-au_blue-600 hover:text-au_primary_hover'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10.73 10.094l9.457 9.457-.637.637-9.457-9.457-9.457 9.457L0 19.55l9.457-9.457L0 .637.636 0l9.457 9.457L19.55 0l.637.637z"/></svg>
          </div>

          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Modal from '~brand-components/base/modal/modal.ts'

export default Modal.extend()
</script>
